import styled from 'styled-components'

import {COLOR} from 'src/service/constant/color'
import {Link} from 'react-router-dom'
import {customMedia} from 'src/styles/common/common'

const TermsWrap = styled.div`
  margin: 64px auto 136px auto;
  display: block;
  min-width: 328px;
  ${customMedia.lessThan("tablet")`
    margin: 24px auto 124px auto;
    max-width: 600px;
    width: 100%;
  `}
  ${customMedia.lessThan("mobile")`
    margin: 24px auto 124px auto;
  `}
`
const TelecomTab = styled.div`
  display: flex;
`
const TelecomTabContent = styled(Link)<{ padding: string; active: string }>`
  border-radius: 30px;
  padding: 13px ${(props) => props.padding};
  font-size: 20px;
  font-family: NanumSquareNeoHeavy, sans-serif;
  color: ${(props) => (props.active === "true" ? COLOR.point1 : COLOR.gray40)};
  background: ${(props) =>
    props.active === "true" ? COLOR.point2 : COLOR.gray10};
  margin: 0 12px 40px 0;

  ${customMedia.lessThan("tablet")`
    margin: 0 12px 9px 0;
    font-size:14px;
    padding: 8.5px 21px;
  `}
`
const TermsOptionWrap = styled.div`
  border-bottom: 1px solid ${COLOR.blueGray2};
  padding-bottom: 7.5px;
  ${customMedia.lessThan("tablet_cut_line")`
    min-width: 328px;
    width: 100%;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  `}
`
const TermsOptionItem = styled(Link)<{ active: string }>`
  font-family: NotoSansMedium, sans-serif;
  font-size: 16px;
  line-height: 23px;
  color: ${(props) =>
    props.active === "true" ? COLOR.black : COLOR.blueGray2};
  border-bottom: ${(props) =>
    props.active === "true" ? `1px solid ${COLOR.black}` : "none"};
  padding: 7.5px;
  ${customMedia.lessThan("tablet")`
     font-size: 14px;
     line-height: 20px;
     width: 100%
  `}
`
const TermsContent = styled.div`
  border-radius: 20px;
  background: ${COLOR.gray10};
  margin-top: 32.5px;

  > pre {
    white-space: pre-wrap;
    margin: 0;
    padding: 34px 34px 106px 34px;
    font-size: 16px;
    line-height: 23px;
    font-family: NotoSansRegular, sans-serif;
  }

  ${customMedia.lessThan("tablet")`
    margin-top: 17px;
    >pre {
      font-size: 14px;
      line-height: 20px;
      padding: 21px 16px 27px 16px;
    }
  `}
`

export const PopupLayer = styled.div`
  padding: 20px;
`
export const MVNOPopupWrap = styled.div`
  margin: 16px 0 16px 0;
  .close-btn {
    width: 20px;
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .top {
    text-align: center;
    
    .description {
      font-family: Noto Sans KR;
      font-size: 18px;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
      margin-bottom: 6px;

    }
    .title {
      margin: 0px;
      font-family: Noto Sans KR;
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
      text-align: center;
  }
}
  .terms-wrap {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    height: 136px;
    border: 1px solid rgb(179, 179, 179);
    border-radius: 10px;
    margin: 16px 0 16px 0;
    overflow: hidden;
  }
  .terms-contents-wrap{
     box-sizing: border-box;
     padding: 12px;
     overflow-y: auto;
     text-align: left;
     background: #f9f9f9;
     margin: 1px;

      //Scrollbar Custom
     ::-webkit-scrollbar {
       width: 1rem;
       position:absolute;
     }
  
     ::-webkit-scrollbar-track {
       box-shadow: none;
       background-color: transparent;
     }
  
     ::-webkit-scrollbar-thumb {
       background-color: #d9d9d9;
        border-radius: 1.25rem;
        border: 0.375rem solid transparent;
       background-clip: content-box;
     }
   }
  
    .terms-contents{
      font-size: 10px;
      margin: 0;
      white-space: break-spaces;
     
    }
    #terms-check {
      display: none;
    }
    .check-wrap{
      width: 109px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
  }
  button {
    width: 100%;
  }
`;

export const TermsCheckBox = styled.label<{ isChecked: boolean }>`
    width: 109px;
    display: inline-block;
    position: relative;
    
    p {
      margin: 0px;
      font-family: Noto Sans KR;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
      white-space: break-spaces;
    }

    .icon {
      display: inline-block;
        width: 24px;
        height: 24px;
        position: relative;
        margin-top: 6px;
        border-radius: 50%;
        border: 1px solid transparent;
        background-color: ${(props) => (props.isChecked ? '#FF4545' : '#ced6e3')};
        @media all and (max-width: 1200px) {
            width: 24px;
            height: 24px;
        }
        ${(props) =>
          props.isChecked
            ? `
                border-color: #FF4545;
              `
            : `
                border-color: #D9D9D9;
              `}
        &:after {
            content: "";
            display: block;
            width: 10px;
            height: 6px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -6px 0 0 -6px;
            border-left: 2px solid transparent;
            border-bottom: 2px solid transparent;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            ${(props) =>
              props.isChecked
                ? `
                    border-color: #FFFFFF;
                  `
                : `
                    border-color: #FFFFFF;
                  `}
        }
`;
export {
  TermsWrap,
  TelecomTab,
  TermsOptionWrap,
  TermsOptionItem,
  TelecomTabContent,
  TermsContent,
}

